import { TapiEndpointFactory, stringifyUrl } from '../baseQuery';

import { campaignsSlice } from '../../campaigns';

export const getCampaignEndpoint: TapiEndpointFactory<'V1CampaignsDetail'> = (
  builder
) =>
  builder.query({
    query: ({ id, query }) => {
      return stringifyUrl(`/campaigns/${id}`, query);
    },

    onQueryStarted: async (arg, { queryFulfilled, dispatch }) => {
      try {
        const response = await queryFulfilled;
        // jsonAPI wraps response in data, so do RTK
        const rawCampaign = response.data;
        dispatch(campaignsSlice.actions.campaignFetched(rawCampaign));
      } catch (error) {
        console.log('error fetching campaign:', error);
      }
    },
  });
